import * as actionTypes from '../actionTypes';
import axios from '../../../_services/api/axios';

/* ------------------ Notifications Machines Fetch ------------------- */
export const helpersNotificationsMachinesFetchStart = () => {
    return {
        type: actionTypes.HELPERS_NOTIFICATIONS_MACHINES_FETCH_START
    };
};

export const helpersNotificationsMachinesFetchSuccess = (list) => {
    return {
        type: actionTypes.HELPERS_NOTIFICATIONS_MACHINES_FETCH_SUCCESS,
        list: list
    };
};

export const helpersNotificationsMachinesFetchFail = ( error ) => {
    return {
        type: actionTypes.HELPERS_NOTIFICATIONS_MACHINES_FETCH_FAIL,
        error: error
    };
};

export const helpersNotificationsMachinesFetch = () => {
    return dispatch => {
        dispatch(helpersNotificationsMachinesFetchStart());
        axios.get( '/production/calculator/machines/notifications')
            .then( response => {
                dispatch( helpersNotificationsMachinesFetchSuccess( response.data.list ) );
            } )
            .catch( error => {
                dispatch( helpersNotificationsMachinesFetchFail( error.response ) );               
            } );
    };
};


// WEBPACK FOOTER //
// ./src/_store/actions/helpers/notifications.js